import { Routes } from '@angular/router';

// Public, unauthenticated outreach pages. The unsubscribe page reads the `?t=`
// JWT minted by send-campaign-outreach (anothertrip-SAM) and is backed by
// /v1/public/outreach/unsubscribe/{token}: GET previews (no commit), POST
// commits the opt-out once the recipient confirms.
export const outreachRoutes: Routes = [
  {
    path: 'outreach/unsubscribe',
    title: 'Unsubscribe · AnotherTrip',
    loadComponent: () => import('./pages/unsubscribe/unsubscribe.page').then((m) => m.UnsubscribePage),
  },
];
